import type { Application } from "../types";

/** Deterministic JSON for “did this application change?” comparisons across debounced persist. */
function stableStringify(value: unknown): string {
  if (value === null) return "null";
  const t = typeof value;
  if (t === "string" || t === "number" || t === "boolean") return JSON.stringify(value);
  if (t === "bigint") return JSON.stringify(String(value));
  if (value === undefined) return "undefined";
  if (Array.isArray(value)) return `[${value.map((v) => stableStringify(v)).join(",")}]`;
  if (t === "object") {
    const rec = value as Record<string, unknown>;
    const keys = Object.keys(rec).sort();
    return `{${keys.map((k) => `${JSON.stringify(k)}:${stableStringify(rec[k])}`).join(",")}}`;
  }
  return JSON.stringify(String(value));
}

export function applicationPersistFingerprint(app: Application): string {
  return stableStringify(app);
}
